import React, {useEffect, useState} from 'react';
import {Box} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import ReceivableItem from './item/item';
import {useContextState as userContext} from '../../../../context/sub-client';
import {IReceivable} from '../../../../interfaces/dtos';
import InternalTemplate from '../../../../components/templates/internal';
import {StackParamList} from '../../../../navigators';
import {SpinnerModal} from '../../../../components/modals';
import {EmptyListIcon} from '../../../../components/icons';
import {isOdd} from '../../../../utils/ui';

interface IReceivableListContent {
  isLoading: boolean;
  receivables: IReceivable[] | null;
}

const ReceivableListContent = ({
  isLoading,
  receivables,
}: IReceivableListContent) => {
  if (isLoading) {
    return <></>;
  }

  if (receivables) {
    return (
      <>
        {receivables.map((deb: IReceivable, index: number) => (
          <ReceivableItem
            key={`balance-item-${index}`}
            {...deb}
            onPress={() => {}}
            rowType={isOdd(index) ? 'odd' : 'even'}
          />
        ))}
      </>
    );
  }

  return <EmptyListIcon />;
};

type ScreenProps = NativeStackScreenProps<StackParamList, 'Receivables'>;

const ReceivableListScreen = ({navigation, route}: ScreenProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const {receivables, fetchReceivableListByDebtor} = userContext();
  const {debtor, key} = route.params;

  const getReceivableList = async () => {
    setIsLoading(true);
    console.info('Antes de   fetchReceivableListByDebtor');
    console.info(
      ' fetchReceivableListByDebtor = ',
      fetchReceivableListByDebtor,
    );
    await fetchReceivableListByDebtor(key, debtor.rif);
    setIsLoading(false);
  };

  useEffect(() => {
    if (debtor) {
      getReceivableList();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGoBack = () => {
    navigation.goBack();
  };

  return (
    <InternalTemplate
      title={debtor.client}
      contentPaddingX="0"
      backButton={{
        onPress: () => handleGoBack(),
        label: 'back-debtors',
        usage: 'external',
      }}>
      <SpinnerModal show={isLoading} />
      <Box marginBottom={20} marginTop={3}>
        <ReceivableListContent
          receivables={receivables}
          isLoading={isLoading}
        />
      </Box>
    </InternalTemplate>
  );
};
export default ReceivableListScreen;
